export type TNativeWaveShaperNode = WaveShaperNode;
